/* eslint-disable @typescript-eslint/explicit-function-return-type */
// istanbul ignore file
import { kpiListErrorAction, kpiListLoadingAction, kpiListUpdateAction } from './kpiListSlice'
import * as kpiListBySearchFilterService from '../services/kpiListBySearchFilterService'
import * as KpiListService from '../services/kpiListService'
import * as DeleteCustomKpiService from '../services/DeleteCustomKpiService'
import { fetchAssetsAndDevices } from '../services/assetListService'
import { assetDeviceLoadingAction, assetDeviceUpdateAction, assetDeviceErrorAction } from './assetListSlice'
import { parameterConfigErrorAction, parameterConfigLoadingAction, parameterConfigUpdateAction } from './deviceParameterSlice'
import * as ParameterConfigService from '../services/deviceParameterService'
import { createCustomKpi, type CreateCustomKpiRequest } from '../services/createCustomKpiService'
import { createCustomKpiLoadingAction, createCustomKpiUpdateAction, createCustomKpiErrorAction } from './createCustomKpiSlice'
import { fetchKpiData } from '../services/customKpiDetailsService'
import { kpiLoadingAction, kpiUpdateAction, kpiErrorAction } from './customKpiDetailsSlice'
import { fetchSites } from '../services/siteListService'
import { siteListLoadingAction, siteListUpdateAction, siteListErrorAction } from './siteListSlice'
import { editKpiErrorAction, editKpiLoadingAction, editKpiUpdateAction } from './editCustomKpiSlice'
import { type EditCustomKpiRequest, editCustomKpi } from '../services/editCustomKpiService'
import { fetchKpiConfigs as fetchKpiConfigsService } from '../services/deviceKpiParameterService'
import {
  kpiConfigLoadingAction,
  kpiConfigUpdateAction,
  kpiConfigErrorAction
} from './deviceKpiParameterSlice'
import { deviceKpiListLoadingAction, deviceKpiListUpdateAction, deviceKpiListErrorAction } from './deviceKpiListSlice'
import * as DeviceKpiListService from '../services/deviceKpiDetailsService'
import { addAssetKpiAlarmLoadingAction, addAssetKpiAlarmUpdateAction, addAssetKpiAlarmErrorAction } from './addAssetKpiAlarmSlice'
import * as AddAssetKpiAlarmService from '../services/addAssetKpiAlarmService'
import { kpiAssetListLoadingAction, kpiAssetListUpdateAction, kpiAssetListErrorAction } from './kpiAssetListSlice'

export const fetchKpiList = (page: any, size: any, sortdir: any, sortfield: any, filter: boolean) => async (dispatch: any): Promise<void> => {
  dispatch(kpiListLoadingAction())
  void KpiListService.getKpiList(page, size, sortdir, sortfield, filter,
    (kpiList, httpStatus) => {
      dispatch(
        kpiListUpdateAction({
          data: kpiList.content,
          count: kpiList.totalCount,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(kpiListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchDeviceKpiList = (assetType: string) => async (dispatch: any): Promise<void> => {
  dispatch(deviceKpiListLoadingAction())
  void DeviceKpiListService.getDeviceLevelKpiList(assetType,
    (kpiList, httpStatus) => {
      dispatch(deviceKpiListUpdateAction({ data: kpiList.content, count: kpiList.totalCount, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(deviceKpiListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchKpiBySearchValue =
  (searchVal: string, filterVal: boolean, page: number, size: number, sortfield: string, sortdir: string) =>
    async (dispatch: any): Promise<void> => {
      dispatch(kpiListLoadingAction())
      void kpiListBySearchFilterService.getKpiBySearchValue(
        searchVal,
        filterVal,
        page,
        size,
        sortfield,
        sortdir,
        (kpiList, httpStatus) => {
          dispatch(
            kpiListUpdateAction({
              data: kpiList.content,
              count: kpiList.totalCount,
              httpStatus
            })
          )
        },
        (errorMessage, httpStatus) => {
          dispatch(kpiListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const deleteCustomKpi =
  (kpiDefinitionId: string, p0: (httpStatus: any) => void, p1: (errorMessage: any, httpStatus: any) => void) =>
    async (dispatch: any): Promise<void> => {
      dispatch(kpiListLoadingAction())
      void DeleteCustomKpiService.deleteCustomKpiByKpiDefinitionId(
        kpiDefinitionId,
        (httpStatus: number) => dispatch(
          kpiListUpdateAction({
            httpStatus,
            data: [],
            count: 0
          })
        ),
        (errorMessage, httpStatus: number) => {
          dispatch(kpiListErrorAction({ errorMessage, httpStatus }))
        }
      )
    }

export const fetchAssetDeviceList = (siteId: string, assetId?: string) => async (dispatch: any): Promise<void> => {
  dispatch(assetDeviceLoadingAction())
  void fetchAssetsAndDevices(
    siteId,
    (data: any, httpStatus) => {
      dispatch(
        assetDeviceUpdateAction({
          data,
          httpStatus
        })
      )
    },
    (errorMessage: string, httpStatus: number) => {
      dispatch(assetDeviceErrorAction({ errorMessage, httpStatus }))
    },
    assetId
  )
}

export const fetchAssetList = (siteId: string) => async (dispatch: any): Promise<void> => {
  dispatch(kpiAssetListLoadingAction())
  void fetchAssetsAndDevices(
    siteId,
    (data: any, httpStatus: number) => {
      dispatch(kpiAssetListUpdateAction({ data, httpStatus }))
    },
    (errorMessage: string, httpStatus: number) => {
      dispatch(kpiAssetListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchDeviceParameters = (assetId: string, assetTypeId: string) => async (dispatch: any): Promise<void> => {
  dispatch(parameterConfigLoadingAction())
  void ParameterConfigService.fetchParameterConfigs(
    assetId,
    assetTypeId,
    (configs: any, httpStatus: any) => {
      dispatch(
        parameterConfigUpdateAction({
          data: configs,
          httpStatus
        })
      )
    },
    (errorMessage: any, httpStatus: any) => {
      dispatch(parameterConfigErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const createCustomKpiAction = (createCustomKpiRequest: CreateCustomKpiRequest) => async (dispatch: any): Promise<void> => {
  dispatch(createCustomKpiLoadingAction())
  void createCustomKpi(
    createCustomKpiRequest,
    (apiResponse: any, httpStatus: number) => {
      dispatch(
        createCustomKpiUpdateAction({
          data: apiResponse, httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(createCustomKpiErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchKpiDetails = (kpiDefinitionId: string, hierarchyId?: string) => async (dispatch: any): Promise<void> => {
  dispatch(kpiLoadingAction())

  void fetchKpiData(
    kpiDefinitionId,
    (kpi, httpStatus) => {
      dispatch(
        kpiUpdateAction({
          data: kpi,
          httpStatus
        })
      )
    },
    (errorMessage: string, httpStatus: number) => {
      dispatch(kpiErrorAction({ errorMessage, httpStatus }))
    },
    hierarchyId
  )
}

export const fetchSiteList = () => async (dispatch: any): Promise<void> => {
  dispatch(siteListLoadingAction())

  void fetchSites(
    (siteList, httpStatus) => {
      dispatch(
        siteListUpdateAction({
          data: siteList,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(siteListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const editCustomKpiDetails = (editKpiRequest: EditCustomKpiRequest, kpiDefinitionId: string) => async (dispatch: any): Promise<void> => {
  dispatch(editKpiLoadingAction())
  void editCustomKpi(
    editKpiRequest,
    kpiDefinitionId,
    (apiResponse: any, httpStatus: number) => {
      dispatch(editKpiUpdateAction({ data: apiResponse, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(editKpiErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchKpiConfigs = (assetId: string, assetTypeId: string) => async (dispatch: any): Promise<void> => {
  dispatch(kpiConfigLoadingAction())
  void fetchKpiConfigsService(
    assetId,
    assetTypeId,
    (configs: any, httpStatus: any) => {
      dispatch(kpiConfigUpdateAction({ data: configs, httpStatus }))
    },
    (errorMessage: any, httpStatus: any) => {
      dispatch(kpiConfigErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const addAssetKpiAlarm = (addAlarmRequest: any, assetId: string) => async (dispatch: any): Promise<void> => {
  dispatch(addAssetKpiAlarmLoadingAction())
  void AddAssetKpiAlarmService.saveAssetKpiAlarm(
    addAlarmRequest, assetId,
    (addAlarmApiResponse: any, httpStatus: number) => {
      dispatch(
        addAssetKpiAlarmUpdateAction({ data: addAlarmApiResponse, httpStatus })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(addAssetKpiAlarmErrorAction({ errorMessage, httpStatus }))
    }
  )
}
